// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from "./components/login/login.component";
import { HomeComponent } from "./components/home/home.component";
import { SettingsComponent } from "./settings/settings.component";
import { AboutComponent } from "./components/about/about.component";
import { NotFoundComponent } from "./components/not-found/not-found.component";
import { AuthService } from './services/auth.service';
import { AuthGuard } from './services/auth-guard.service';
import { ReprezentariComponent } from './components/reprezentari/reprezentari.component';
import { ReprezentantiComponent } from "./components/reprezentanti/reprezentanti.component";
import { ContulMeuComponent } from "./components/contulmeu/contulmeu.component";
import { PozeComponent } from "./components/poze/poze.component";
import { CompanieComponent } from "./components/companie/companie.component";
import { CompanieReprezentariComponent } from "./components/companieReprezentari/companieReprezentari.component";
import { CarComponent } from "./components/car/car.component";
import { ProductComponent } from "./components/product/product.component";
import { OfferComponent } from "./components/offer/offer.component";
import { ConfiguratorComponent } from "./components/configurator/configurator.component";
import { CatalogLinkComponent } from './components/catalogLink/catalogLink.component';
import { AuditLoginComponent } from './components/auditLogin/auditLogin.component';

const routes: Routes = [
  { path: "", component: ConfiguratorComponent, data: { title: "Configurator" } },
  { path: "login", component: LoginComponent, data: { title: "Login" } },
  { path: "settings", component: SettingsComponent, canActivate: [AuthGuard], data: { title: "Settings" } },
  { path: "about", component: AboutComponent, data: { title: "About Us" } },
  { path: "home", redirectTo: "/", pathMatch: "full" },
  { path: "reprezentari", component: ReprezentariComponent, canActivate: [AuthGuard], data: { title: "Represented companies" } },
  { path: "contulmeu", component: ContulMeuComponent, canActivate: [AuthGuard], data: { title: "Contul meu" } },
  { path: "poze", component: PozeComponent, canActivate: [AuthGuard], data: { title: "Photo info" } },
  { path: "reprezentanti", component: ReprezentantiComponent, canActivate: [AuthGuard], data: { title: "Users personal info" } },
  { path: "companie", component: CompanieComponent, canActivate: [AuthGuard], data: { title: "Company details" } },
  { path: "companiereprezentari", component: CompanieReprezentariComponent, canActivate: [AuthGuard], data: { title: "Detalii reprezentari" } },
  { path: "car", component: CarComponent, canActivate: [AuthGuard], data: { title: "Vehicle configuration" } },
  { path: "product", component: ProductComponent, canActivate: [AuthGuard], data: { title: "Vehicle product" } },
  { path: "offer", component: OfferComponent, canActivate: [AuthGuard], data: { title: "Offer product" } },
  { path: "cataloglink", component: CatalogLinkComponent, canActivate: [AuthGuard], data: { title: "Catalog Link" } },
  { path: "configurator", component: ConfiguratorComponent, data: { title: "Configurator" } },
  { path: "auditlogin", component: AuditLoginComponent, canActivate: [AuthGuard], data: { title: "Audit login" } },
  { path: "**", component: NotFoundComponent, data: { title: "Page Not Found" } },
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthService, AuthGuard]
})
export class AppRoutingModule { }
